import { useCompanyContext } from '@/lib/context/companyContext'
import { lightPalette } from '@/app/styles/themes/colors'
import { TypographyVariants } from '@/app/styles/themes/typography'
import { Divider, Stack, Typography } from '@mui/material'

const CompanyName = () => {
	const { selectedCompany } = useCompanyContext()
	const companyName = selectedCompany?.companyNm
	return (
		<>
			<Divider sx={{ marginTop: '8px', marginBottom: '7px' }} />
			{companyName && (
				<Stack sx={{ my: 2, paddingLeft: '12px', paddingRight: '12px' }}>
					<Typography
						variant={TypographyVariants.smallSemiBold}
						sx={{ color: lightPalette.foreground.neutral.onSurfaceVar01 }}
					>
						{companyName}
					</Typography>
				</Stack>
			)}
		</>
	)
}
export default CompanyName
